// /me/inbox (wave 13, w13-notify): every notification from accounts, community and social in one list, newest
// first, with the switches a click away. The bell in the global bar shows the latest of the same list.

import { bellStyles, emptyInbox, inboxChanged, inboxList, namesFor } from "../bell.ts";
import { getCatalogue } from "../catalogue.ts";
import { clear, errorBox, h, link } from "../dom.ts";
import { loadInbox, markRead, prefsOf } from "../notify.ts";
import { navigate, setTitle } from "../router.ts";
import { signedIn } from "../session.ts";
import { accountStyles, getFullMe } from "./me-kit.ts";

export async function inboxPage(): Promise<HTMLElement> {
  setTitle("Notifications");
  accountStyles();
  bellStyles();
  if (!signedIn()) {
    navigate(`/signin?next=${encodeURIComponent("/me/inbox")}`, true);
    return h("div");
  }
  const body = h("div", { class: "inbox-page-body" }, h("p", { class: "dim" }, "Loading…"));
  const readAll = h("button", { class: "btn ghost small", type: "button", hidden: "" }, "Mark all read");
  const root = h(
    "div",
    { class: "acct acct-page inbox-page" },
    h(
      "header",
      { class: "set-head inbox-head" },
      h("div", null, h("p", { class: "kicker" }, "Your space"), h("h1", null, "Notifications")),
      h("div", { class: "acct-row" }, readAll, link("/me/settings#notifications", { class: "btn ghost small" }, "Choose what you get")),
    ),
    body,
  );
  root.append(h("style", null, `.inbox-page { max-width: 760px; } .inbox-head { display: flex; justify-content: space-between; align-items: end; gap: 16px; flex-wrap: wrap; margin-bottom: 20px; } .inbox-page-body { background: var(--panel); border: 1px solid var(--border); border-radius: 14px; padding: 6px; }`));
  try {
    const [me, cat] = await Promise.all([getFullMe(), getCatalogue().catch(() => null)]);
    const inbox = await loadInbox(prefsOf(me.notify));
    const names = await namesFor(inbox.items, cat);
    const list = inboxList(inbox.items, names, () => setTimeout(inboxChanged, 300));
    clear(
      body,
      list.childElementCount ? list : emptyInbox(),
      inbox.missing.length ? h("p", { class: "inbox-missing" }, "Some notifications couldn't load. They'll be back shortly.") : null,
    );
    if (inbox.unread) {
      readAll.removeAttribute("hidden");
      readAll.addEventListener("click", async () => {
        readAll.setAttribute("hidden", "");
        body.querySelectorAll(".inbox-row.unread").forEach((el) => el.classList.remove("unread"));
        await markRead("all");
        inboxChanged();
      });
    }
  } catch (e) {
    clear(body, errorBox(e));
  }
  return root;
}
